import useMutation from './useMutation';

const sendFileToPulse = (axios, params) => {
  return axios.post('files', params);
};

const useSendFiles = options => {
  return useMutation({
    mutationFn: sendFileToPulse,
    options: options
  });
};

export default useSendFiles;
